import { Link } from "react-router-dom";

const sections = [
  {
    title: "What we collect",
    body: "When you apply for coaching or chat with us on WhatsApp, we collect your name, age, WhatsApp number, Instagram handle, fitness goals, training history and any messages you send us. We collect only what is needed to provide coaching services.",
  },
  {
    title: "How we use it",
    body: "Your information is used to review your coaching application, run automated WhatsApp conversations (including qualifying questions and call scheduling), contact you about your application and deliver coaching services. We do not sell your data to anyone.",
  },
  {
    title: "WhatsApp messages",
    body: "Conversations with our WhatsApp assistant are processed through the Meta WhatsApp Business Platform and stored securely so we can continue your coaching conversation. You can stop the conversation at any time by telling us or by blocking the number.",
  },
  {
    title: "Data retention and deletion",
    body: "Application and conversation data is kept while your enquiry or coaching relationship is active. To request deletion of your data, message us on WhatsApp or email us and we will remove it.",
  },
  {
    title: "Contact",
    body: "Strength Syndicate. For any privacy questions, reach us on WhatsApp or via Instagram @nimishhgulati.",
  },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#0a0a0c] text-[#f4f4f6]" data-testid="privacy-page">
      <nav className="border-b border-white/10 backdrop-blur-xl bg-black/70">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
          <Link to="/" data-testid="privacy-nav-logo" className="block py-2">
            <img src="/logo.png" alt="Strength Syndicate" className="h-16 w-auto" />
          </Link>
          <span className="font-mono-alt text-[11px] tracking-[0.25em] uppercase text-zinc-500">Privacy Policy</span>
        </div>
      </nav>
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
        <h1 className="font-display uppercase text-4xl sm:text-5xl leading-tight mb-4">Privacy Policy</h1>
        <p className="text-sm text-zinc-500 mb-12">Last updated: September 2026</p>
        <div className="space-y-10">
          {sections.map((s, i) => (
            <div key={s.title} data-testid={`privacy-section-${i}`}>
              <h2 className="font-display uppercase text-xl mb-3 text-[#ff3823]">{s.title}</h2>
              <p className="text-base text-zinc-300 leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 pt-8 border-t border-white/10">
          <Link to="/" className="font-mono-alt text-[11px] tracking-[0.25em] uppercase text-zinc-500 hover:text-white transition-colors" data-testid="privacy-back-link">
            Back to site
          </Link>
        </div>
      </div>
    </div>
  );
}
